import { exercisesStats } from '../../../reducers/exercises-reducer';
import { SettingMode, IN_PERFORMANCE_ACTION_TYPES } from '../../../constants/constants';
import { trackEvent } from '../../../services/analytics';
import { getInPerformanceTrackingProps } from '../../../zustand/session-metadata-store';
import MenuIcon from '../../../assets/svgs/heroicons-solid_menu-alt-4.svg';

const BordersAndSettingIcon = ({ dispatch, timer, sendJsonMessage }) => {
  const handleOpenSettingModal = () => {
    trackEvent('INPERFORMANCE_ACTION', {
      ...getInPerformanceTrackingProps(),
      action_type: IN_PERFORMANCE_ACTION_TYPES.PAUSE_SESSION,
    });
    dispatch({ type: exercisesStats.openSettingModel, payload: true });
    dispatch({ type: exercisesStats.stopSend, payload: false });
    timer?.pause?.();
    sendJsonMessage?.({
      pause: {
        action: SettingMode.pause,
      },
    });
  };

  return (
    <button
      type="button"
      tw="flex h-5 w-5 sm:h-6 sm:w-6 lg:h-8 lg:w-8"
      onClick={handleOpenSettingModal}
      aria-label="Open exercise settings"
      title="Exercise settings"
      data-testid="menu"
    >
      <img loading="lazy" decoding="async" src={MenuIcon} alt="settings" tw="w-full h-full" />
    </button>
  );
};

export default BordersAndSettingIcon;
